// @flow

import gql from 'graphql-tag';
import React, { type Node } from 'react';
import { get } from 'lodash';

import { Query } from '@apollo/react-components'; // eslint-disable-line no-restricted-syntax
import { Invitation } from '@zapier/authentication';

type ChildrenProps = {
  accountName: ?string,
  email: ?string,
  isInviting: boolean,
  isLoading: boolean,
  teamLogoUrl: ?string,
  invitation: ?Invitation,
};

type Props = {
  children: ChildrenProps => Node,
  code: ?string,
};

const invitationByCodeQuery = gql`
  query InvitationByCode($code: String!) {
    invitationByCode(code: $code) {
      account {
        logoUrl
        name
      }
      email
      id
    }
  }
`;

const WithInvitationByCode = (props: Props) => {
  return (
    <Query
      query={invitationByCodeQuery}
      skip={!props.code}
      variables={{
        code: props.code,
      }}
    >
      {results => {
        const invitation = get(results, ['data', 'invitationByCode']);
        const accountName = get(invitation, ['account', 'name']);
        const teamLogoUrl = get(invitation, ['account', 'logoUrl']);
        const email = get(invitation, ['email']);

        return props.children({
          accountName,
          email,
          isInviting: Boolean(invitation),
          isLoading: results.loading,
          teamLogoUrl,
          invitation,
        });
      }}
    </Query>
  );
};

export default WithInvitationByCode;
